/* EGR on Shopify — information pages: wholesale, contact, FAQ, shipping, research-use policy, partners, 404.
   Contact, wholesale and partner forms are Shopify contact forms (rendered in sections/egr-page.liquid):
   messages go to the store's contact email and appear in the Shopify admin's notifications. */
(function () {
  "use strict";
  const EGR = window.EGR;
  const { $, $$, esc, moneyShort } = EGR.u;
  const P = EGR.data.promo;
  const B = EGR.data.brand;
  const icon = EGR.icon;
  EGR.pages = EGR.pages || {};
  const hasLots = EGR.catalog.allLots.length > 0;

  const tiles = (rows) => rows.map(([ic, tone, h, p], i) => `<div class="tile reveal" style="--d:${0.05 * i}s"><span class="tile-icon" style="background:var(--${tone});color:var(--${tone}-ink)">${icon(ic)}</span><h3>${h}</h3><p>${p}</p></div>`).join("");

  EGR.pages.wholesale = {
    title: "Wholesale · EGR",
    init() {
      $("#ws-tiles").innerHTML = tiles([
        ["percent", "butter", "Volume pricing", "Standing and large-volume orders are quoted directly, per compound and strength."],
        hasLots
          ? ["fileCheck", "lilac", "A certificate for every lot", "Every vial in a wholesale order ships from a released lot with its certificate published."]
          : ["fileCheck", "lilac", "Lot-tracked supply", "Every vial carries the lot number it was filled from, so each order is traceable to its batch."],
        ["snow", "aqua", "Cold-packed and fast", "Dispatched in 0–2 business days in insulated packaging with a cold pack."],
        ["chat", "blush", "A direct line", `A researcher on our team handles your account and replies ${esc(B.replyTime)}.`]
      ]);
    }
  };

  EGR.pages.contact = {
    title: "Contact · EGR",
    init() {
      $$("[data-brand-email]").forEach((a) => {
        if (B.email) { a.href = `mailto:${B.email}`; a.textContent = B.email; }
        else { a.href = "#contact-form"; a.textContent = "Use the form below"; }
      });
      const extra = [B.phone ? `Phone: ${esc(B.phone)}` : "", B.address ? esc(B.address) : ""].filter(Boolean);
      $$("[data-brand-extra]").forEach((p) => { p.innerHTML = extra.join("<br>"); p.hidden = !extra.length; });
      const t = new URLSearchParams(location.search).get("topic");
      if (t && $("#topic")) $("#topic").value = t;
    }
  };

  EGR.pages.faq = {
    title: "FAQ · EGR",
    init() {
      $("#faq-all").innerHTML = EGR.faqHtml(EGR.content.faq.concat([
        ["Do you offer discounts on larger orders?", `Yes. Volume and standing orders are quoted directly: tell us what your lab needs on the <a href="wholesale.html">wholesale page</a>. Any discount you're eligible for is applied at checkout.`],
        ["How do I pay?", "Checkout is handled securely by Shopify. The payment methods available to you are shown at checkout."]
      ]));
      EGR.wireFaq($("#faq-all"));
    }
  };

  EGR.pages.shipping = {
    title: "Shipping · EGR",
    init() {
      const el = $("#free-over");
      if (!el) return;
      const tile = el.closest(".tile");
      if (P.freeShippingOver) el.textContent = moneyShort(P.freeShippingOver);
      else if (tile) {
        tile.querySelector("h3").textContent = "Rates at checkout";
        tile.querySelector("p").textContent = "Shipping options and rates for your address are shown at checkout before you pay.";
      }
    }
  };

  // Research-use policy and disclaimer (the store's terms, privacy, refund and shipping
  // policies are Shopify policies, edited in Settings > Policies).
  EGR.pages.legal = {
    title: "Research-use policy · EGR",
    init() {
      const L = EGR.content.legal;
      const nav = [["Terms of service", "legal.html?doc=terms"], ["Privacy policy", "legal.html?doc=privacy"], ["Refund policy", "legal.html?doc=returns"], ["Shipping policy", "legal.html?doc=shipping-policy"], ["Research use", "legal.html?doc=research-use", true]];
      $("#legal-nav").innerHTML = nav.map(([l, h, on]) => `<a class="chip" href="${h}"${on ? ' aria-pressed="true"' : ""}>${l}</a>`).join("");
      $("#legal-title").textContent = L["research-use"].title;
      $("#legal-body").innerHTML = L["research-use"].body.replace(/\{warn\}/g, icon("warn")) +
        `<h2 id="disclaimer">${esc(L.disclaimer.title)}</h2>` + L.disclaimer.body.replace(/\{warn\}/g, icon("warn"));
      if (location.hash === "#disclaimer") setTimeout(() => { const d = $("#disclaimer"); d && d.scrollIntoView(); }, 50);
    }
  };

  EGR.pages.affiliates = { title: "Partner programme · EGR", init() {} };
  EGR.pages.notfound = { title: "Page not found · EGR", init() {} };
})();
